import { ISpecificationTemplate, ISpecificationTemplateDetailResponse } from "@/shared/services/interface/responses/ISpecificationTemplate";
import { createSlice } from "@reduxjs/toolkit";
import { getSpecificationTemplate, getSpecificationTemplates } from "../thunks/specificationTemplateThunk";


interface ISpecificationTemplateState {
    detail: ISpecificationTemplateDetailResponse | null;
    list: ISpecificationTemplate[];
    isLoading: boolean;
    isLoadingList: boolean;
    error: string | null;
    activeIndex: number;
    open: boolean;
    currentTemplate: ISpecificationTemplateDetailResponse | null;
}

const initialState: ISpecificationTemplateState = {
    detail: null,
    list: [],
    isLoading: false,
    isLoadingList: false,
    error: null,
    activeIndex: 0,
    open: false,
    currentTemplate: null
}

const specificationTemplateSlice = createSlice({
    name: 'specificationTemplate',
    initialState,
    reducers: {
        resetDetail: (state) => {
            state.detail = null;
            state.isLoading = false;
            state.error = null;
        },
        resetTemplateList: (state) => {
            state.list = [];
            state.isLoadingList = false;
            state.error = null;
        },
        setActiveIndex: (state, action) => {
            state.activeIndex = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setCurrentTemplate: (state, action) => {
            state.currentTemplate = action.payload;
        },
        setOpenAndCurrentTemplate: (state, action) => {
            state.currentTemplate = action.payload.currentTemplate;
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSpecificationTemplate.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(getSpecificationTemplate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.detail = action.payload;
        })
        builder.addCase(getSpecificationTemplate.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload as string;
        })
        builder.addCase(getSpecificationTemplates.pending, (state) => {
            state.isLoadingList = true;
        })
        builder.addCase(getSpecificationTemplates.fulfilled, (state, action) => {
            state.isLoadingList = false;
            state.list = action.payload;
        })
        builder.addCase(getSpecificationTemplates.rejected, (state, action) => {
            state.isLoadingList = false;
            state.error = action.payload as string;
        })
    }
})

export const { resetDetail, resetTemplateList, setActiveIndex, setOpen, setCurrentTemplate,setOpenAndCurrentTemplate } = specificationTemplateSlice.actions;
export default specificationTemplateSlice.reducer;
